import { Modal } from 'react-bootstrap'
import { logout } from '../../Redux/auth/AuthSlice';
import { useDispatch } from 'react-redux';

const LogoutModal = ({ show, hide }) => {
    const dispatch = useDispatch();

    const handleLogout = async () => {
        dispatch(logout())
        hide()
    };
    return (
        <>
            <Modal show={show} onHide={hide} centered>
                <Modal.Body>
                    <div className="profile-modals-cmn">
                        <h2>Log Out</h2>
                        <p>Are you sure you want to log out your account?</p>
                    </div>
                    <div className="cmn-modal-action">
                        <button onClick={hide}>Close</button>
                        <button onClick={() => handleLogout()} style={{ background: 'linear-gradient(0deg, rgba(52, 87, 213, 0.8) 0%, #3457d5 100%)' }} className="border-0">Log Out</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default LogoutModal
